export enum ActionTypes {
  POST_SAMPLE_SIZE_REQUEST = '@@calculator/POST_SAMPLE_SIZE_REQUEST',
  POST_SAMPLE_SIZE_SUCCESS = '@@calculator/POST_SAMPLE_SIZE_SUCCESS',
  POST_SAMPLE_SIZE_FAILURE = '@@calculator/POST_SAMPLE_SIZE_FAILURE',
}
